<template>
  <v-dialog v-model="dialog" scrollable persistent max-width="600px">
    <v-card>
      <v-toolbar color="primary" flat style="color: white;">
        <v-toolbar-title>Dados Cliente :</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn icon>
          <v-icon @click="dialog = false" style="color: white;">mdi-close</v-icon>
        </v-btn>

        <template v-slot:extension>

          <v-tabs v-model="tab" grow style="background-color:rgba(255, 255, 255, 1);color: black;">
            <v-tabs-slider></v-tabs-slider>

            <v-tab style="color: black;">
              Geral
            </v-tab>
            <v-tab style="color: black;">
              Moradas
            </v-tab>

          </v-tabs>
        </template>
      </v-toolbar>

      <v-card-text>

        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field filled label="Nome" readonly auto-grow v-model="client.name"></v-text-field>
                    </v-col>

                    <v-col cols="12">
                      <v-text-field filled label="NIF" readonly auto-grow v-model="client.nif"></v-text-field>
                    </v-col>

                    <v-col cols="12">
                      <v-textarea filled label="Contactos" readonly auto-grow v-model="client.contacts"></v-textarea>
                    </v-col>

                    <v-col cols="12">
                      <v-text-field filled label="Email" readonly auto-grow v-model="client.email"></v-text-field>
                    </v-col>

                    <v-col cols="12">
                      <v-text-field filled label="Zona" readonly auto-grow v-model="client.zone"></v-text-field>
                    </v-col>

                    <v-col cols="12">
                      <v-text-field filled label="Limite Crédito (Dias)" readonly auto-grow
                        v-model="client.creditLimitDays"></v-text-field>
                    </v-col>

                    <v-col cols="12">
                      <v-text-field filled label="Limite Crédito (EUR)" readonly auto-grow
                        v-model="client.creditLimitValue"></v-text-field>
                    </v-col>

                    <v-col cols="12">
                      <v-checkbox v-model="client.creditBlocked" label="Crédito Bloqueado" readonly></v-checkbox>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" v-for="address in client.Addresses" :key="address.id">
                      <v-textarea filled readonly auto-grow v-model="address.value"></v-textarea>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-dialog>
</template>

<script>
import ServiceClient from "@/services/ServiceClient";
export default {
  name: "ViewDialogUser",
  data() {
    return {
      overlay: false,
      tab: null,
      dialog: false,
      client: {}
    };
  },
  methods: {
    async open(id) {
      try {
        this.dialog = true;
        this.overlay = true;
        const response = await ServiceClient.getFullInfo(id);

        this.client = response.data;
      } catch (error) {
        this.$store.dispatch("setSnackbar", {
          color: "error",
          text: error
        });
      }

      this.overlay = false;
    }
  },
  async mounted() { }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
